import React, {useState} from 'react'
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap";


// components
import NotificationForm from "../../../comunication/notification/_form";
import NotificationsList from "./_list";

// labels
import {NOTIFICATION} from "../../../../components/i18n/i18n";

// styles
import '../../../../assets/css/notifications.css'
import CardTitleComponent from "../../../../components/genericComponents/CardTitleComponent";


const NotificationComponent = props => {
    const { data, onClose } = props
    const { id, notifications= [] } = data
    const activity = { id }
    const [showNotificationForm, setShowNotificationForm] = useState(notifications.length > 0 ? false : true)

    return <Card className={'notification-modal-container'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <CardTitleComponent
                icon={'far fa-edit'}
                title={NOTIFICATION}
                onClose={ onClose }
                onAdd={ !showNotificationForm && setShowNotificationForm }
            />
        </CardTitle>
        <CardBody>
            {
                showNotificationForm
                    ? <NotificationForm
                        data={activity}
                        from={'activity'}
                        onClose={onClose}
                    />
                    : <NotificationsList
                        activity={activity}
                        notifications={notifications}
                        onClose={onClose}
                    />
            }
        </CardBody>
    </Card>
}

export default  NotificationComponent